import { motion } from 'framer-motion'
import React from 'react'
import {  Expo } from "gsap/all";

function TransitionComp({children}: {children: JSX.Element}) {
  return (
    <motion.div
        className="overlay" 
        style={{zIndex: '999'}}
        animate={{
           y: '-100%',
            animationDuration: "0.5",
            transition: { duration: 1 ,    ease:Expo.easeInOut},
          
          }}
          initial={{ y: 0,  transitionDelay: "0.5" }}
          exit={{y: 0,  transition: { duration: 1 ,stiffness: 10,ease:Expo.easeInOut   }, }}
        // transition={{ type: "spring",   duration: 5 ,delay: 3}}
        // variants={postVariants}
      >
        {
            children
        }
      </motion.div>
  )
}

export default TransitionComp